module.exports = __webpack_public_path__ + "static/media/logo.2b362308.svg";